// Margin by which a server row's createdAt must EXCEED the local save
// timestamp to count as a genuine external (Gmail web) edit. The backend's
// own echo of a save is always a little OLDER than the local commit that
// triggered it (its createdAt is the API Lambda's own clock when it called
// Gmail, which happens after the local save), so anything within this
// margin is our own echo, not confirmation.
export const CONFIRMATION_CLOCK_SKEW_MS = 30_000;

// After this long since the last local save with no confirming external
// edit, the server becomes the truth again regardless of freshness: a
// present server row wins outright, an absent one drops the local row. Also
// what eventually clears a draft deleted in Gmail web, since a delete there
// never produces a confirming row.
export const UNCONFIRMED_DRAFT_TTL_MS = 15 * 60_000;

export const COMPOSE_SNAPSHOT_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export const COMPOSE_SNAPSHOT_MAX_PER_USER = 20;

// Real (decoded) bytes, matching Gmail's own 25 MB message limit.
export const COMPOSE_SNAPSHOT_MAX_ATTACHMENT_BYTES = 25 * 1024 * 1024;

export const BASE64_PADDING_CHAR = '=';

export const BASE64_MAX_PADDING = 2;

export const BASE64_CHARS_PER_GROUP = 4;

export const BASE64_BYTES_PER_GROUP = 3;

export const COMPOSE_SNAPSHOT_WRITE_DEBOUNCE_MS = 1000;

export const COMPOSE_SNAPSHOT_ORPHAN_GRACE_MS = 60_000;

// Autosave/snapshot triggers that cascade out of a restore revert must not re-record it.
export const COMPOSE_SNAPSHOT_SETTLE_WINDOW_MS = 750;

export const COMPOSE_RECOVERY_TOAST_DURATION_MS = 30 * 60_000;

export const COMPOSE_REVERT_TOAST_DURATION_MS = 8000;

// Backoff after a failed draft save; the last entry repeats until a save succeeds.
export const DRAFT_AUTO_RETRY_DELAYS_MS = [
  10_000, 30_000, 60_000, 120_000, 300_000,
] as const;

export const HTTP_STATUS_PAYLOAD_TOO_LARGE = 413;

// Lambda's synchronous invoke limit (6 MiB) minus room for the API Gateway event envelope and headers.
export const MAX_EMAIL_REQUEST_BYTES = 6 * 1024 * 1024 - 64 * 1024;
